import { Injectable } from '@angular/core';
import {
  AuthHttpHeaderService,
  AuthRedirectService,
  AuthService,
  AuthStorageService,
  GlobalMessageService,
  GlobalMessageType,
  OAuthLibWrapperService,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class KbAuthHttpHeaderService extends AuthHttpHeaderService {
  constructor(
    authService: AuthService,
    authStorageService: AuthStorageService,
    oAuthLibWrapperService: OAuthLibWrapperService,
    routingService: RoutingService,
    occEndpoints: OccEndpointsService,
    globalMessageService: GlobalMessageService,
    authRedirectService: AuthRedirectService,
  ) {
    super(
      authService,
      authStorageService,
      oAuthLibWrapperService,
      routingService,
      occEndpoints,
      globalMessageService,
      authRedirectService,
    );
  }

  override handleExpiredRefreshToken(): void {
    this.authRedirectService.saveCurrentNavigationUrl();
    this.authService.coreLogout().finally(() => {
      this.routingService.go({ cxRoute: 'home' });
      this.globalMessageService.add(
        { key: 'httpHandlers.sessionExpired' },
        GlobalMessageType.MSG_TYPE_ERROR,
      );
    });
  }
}
